import styled from "styled-components";
import { device } from "../../styles/devices";

export const SkillsContent = styled.section`
    padding: 5rem 0;
    margin: 3rem 0;

    @media ${device.tablet}{
        margin: 0;
        padding: 3rem 0;
    }
    h2 {
        font-size: 2.5rem;
        line-height: 3rem;
        color: var(--color-title);
        margin-bottom: 0.5rem;
        text-align: center;

        @media ${device.tabletLarge}{
            font-size: 2.5rem;
            line-height: 3rem;
        }

        @media ${device.tablet}{
            font-size: 2rem;
            line-height: 2.5rem;
        }

        @media ${device.mobile}{
            text-align: initial;
        }
    }

    & > div > p {
        font-size: 1rem;
        font-weight: var(--font-normal);
        text-align: center;
        color: var(--color-text);

        @media ${device.mobile}{
            text-align: initial;
        }
    }
`;
export const SkillsContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    padding: 0 20px;
`;

export const SkillsGrid = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 3rem;
    margin-top: 2rem;

    @media ${device.tabletLarge}{
        grid-template-columns: repeat(1, 1fr);
        gap: 1.5rem;
    }

    @media ${device.tablet}{
        grid-template-columns: repeat(1, 1fr);
        gap: 1.5rem;
    }
`;